import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useFirebaseLogin } from "@/app/hooks/api_hooks/auth/useFirebaseLogin";
import { useConfiguration } from "@/app/hooks/useConfiguration";

import { useRouter } from "@/app/hooks/useRouter";
import { MdInstallDesktop } from "react-icons/md";

const AppVersionChangeModal = () => {
  const { clientSignOut } = useFirebaseLogin();
  const { getRouteKey } = useRouter();

  const {
    env: { version: appVersion },
  } = useConfiguration();
  return (
    <ModalPrompt
      modalId="APP_VERSION_CHANGE_MODAL"
      persistent
      showIcon
      titleIcon={
        <span className="text-green-800">
          <MdInstallDesktop />
        </span>
      }
      titleIconContainerClassName="bg-green-100"
      titleIconClassName="bg-green-500"
      button={{
        primaryButtonText: "✨ Install",
        secondaryButtonText: "",
        primaryButtonClassname:
          "rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
        primaryCallback: () => {
          clientSignOut();
          window.open(getRouteKey("LOGIN_PAGE", "url"), "_self");
        },
        shouldHideOnClick: true,
      }}
      title="New VMS Version"
      content={
        <span className="text-xs">
          Please update your VMS version to <span className="font-mono font-semibold">{appVersion}</span> so use all new
          features.
        </span>
      }
    />
  );
};

export default AppVersionChangeModal;
